/**
 * Container for All Punch View
 */
import React, { useState, useEffect, useRef } from "react";
import Alert from "@material-ui/lab/Alert";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { Button } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import { Box, CircularProgress, makeStyles, Grid } from "@material-ui/core";
import moment, { duration } from "moment";
import MUIDataTable from "mui-datatables";
import Typography from "@material-ui/core/Typography";
import { dateConfig, SET_EMPTY } from "config";
import { getPunchesReportData, date, time } from "utils/report";
import { createMuiTheme, MuiThemeProvider } from "@material-ui/core/styles";
import { Link } from "react-router-dom";
import {
  ADD_EDIT_PUNCH_SUPERVISOR,
  SUPERVISOR_PTO,
  ALLPUNCH_DURATION,
} from "navigation/CONSTANTS";
import {
  APPROVED_STATUS,
  EDIT_STATUS,
  NEW_STATUS,
  PENDING_STATUS,
  INCOMPLETE_STATUS,
  EXCEPTION_STATUS,
  INCOMPLETE_BG_INVALID,
  INCOMPLETE_BG_VALID,
} from "config";
import LoadingButton from "components/LoadingButton";
import { approvePunch, deletePunch } from "services";
import { REVIEW } from "../../../navigation/CONSTANTS";
import { useHistory } from "react-router-dom";
import { MANAGE_FOR_BY_COUNTRY, OTHER_TEAM } from "config/CONSTANTS";
import { PTO } from "config";
import { Card } from "@material-ui/core";
import { downloadFileNameAllPunch } from "config";
import { properCase } from "../../../utils";
import { useDispatch } from "react-redux";
import { saveAllPunchViewFilterList } from "redux/actions/appActions";

import {
  defaultPaginationOptions,
  defaultRowsPerPage,
  DELETED_STATUS,
  DURATION_GT_12,
  getTextLabels,
  TWELVE,
} from "../../../config/index";
import { udpatePunchStatus } from "utils/activity";

export const AllPunchView = (props) => {
  const history = useHistory();
  const SUCCESS_MSG_SHOWTIME = 5000;
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(true);
  const [loadingError, setLoadingError] = useState(SET_EMPTY);
  const [data, setData] = useState([]);
  const [rowsSelected, setRowsSelected] = useState([]);
  const [selectedPunches, setSelectedPunches] = useState([]);
  const [isApproveLoading, setIsApproveLoading] = useState(false);
  const [approveError, setApproveError] = useState("");
  const [approveSuccess, setApproveSuccess] = useState("");
  const [isDeleteLoading, setIsDeleteLoading] = useState(false);
  const [deleteError, setDeleteError] = useState("");
  const [deleteSuccess, setDeleteSuccess] = useState("");
  const dispath = useDispatch();
  const {
    allPunchViewFiltersData,
    selectedManagerForApproval,
    selectedTeamOnReview,
  } = useSelector((state) => state.appConfig);
  //console.log("------allPunchViewFiltersData-------",allPunchViewFiltersData);

  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });
  const { user, isLoading: userLoading } = useSelector(
    (state) => state.user.auth
  );
  const blank = properCase(t("pgReview.tableStaticText.blank"));
  const reportTheme = createMuiTheme({
    overrides: {
      MuiTableCell: {
        root: {
          padding: 6,
        },
      },
      MUIDataTableToolbarSelect: {
        root: {
          paddingTop: 18,
          paddingBottom: 18,
        },
      },
      MuiInput: {
        underline: {
          "&&:after": {
            borderBottom: "2px solid #1B75BC",
          },
        },
      },
      MuiInputLabel: {
        root: {
          "&$focused": {
            color: "#1B75BC",
          },
        },
      },
      MuiCheckbox: {
        colorPrimary: {
          "&$checked": {
            color: "#1B75BC",
          },
        },
      },
      MuiChip: {
        outlinedPrimary: {
          color: "#1B75BC",
          border: "1px solid #1B75BC",
        },
      },
      MuiChip: {
        deleteIcon: {
          color: "#1B75BC",
        },
      },
      MUIDataTableToolbar: {
        iconActive: {
          color: "#1B75BC",
        },
        icon: {
          "&&:hover": {
            color: "#1B75BC",
          },
        },
      },
      MuiButton: {
        textPrimary: {
          color: "#1B75BC",
        },
        "&&:hover": {
          color: "#1B75BC",
        },
      },
      MuiTypography: {
        body2: {
          color: "#1B75BC",
        },
      },
    },
  });

  const useStyles = makeStyles((theme) => ({
    dialog: {
      padding: theme.spacing(2),
      position: "absolute",
      top: theme.spacing(5),
    },
    dialogContent: {
      textAlign: "left",
    },
    dialogAction: {
      justifyContent: "flex",
    },
    hideElem: {
      display: "none",
    },
    container: {
      marginTop: 10,
      background: "#1B75BC",
      color: "white",
      fontSize: 16,
      fontWeight: "bolder",
      minHeight: 40,
      width: "100%",
      lineHeight: 3,
    },
    label1: {
      marginLeft: 80,
    },
    label2: {
      marginLeft: 30,
      width: "100%",
    },
  }));

  const classes = useStyles();

  useEffect(() => {
    setIsLoading(true);
    setLoadingError(SET_EMPTY);
    if (user.workerId && !userLoading) {
      let startDate, endDate;
      if (props.weekStartDate) {
        startDate = moment(props.weekStartDate).format(dateConfig.format6);
        endDate = moment(new Date(props.weekStartDate))
          .add(7, "days")
          .format(dateConfig.format6);
      }
      let managerId;
      if (props.selectedTeam === OTHER_TEAM) {
        managerId = props.allWorkers.otherManagerId;
      } else {
        managerId = user.workerId;
      }

      getPunchesReportData(managerId, startDate, endDate)
        .then((data) => {
          //commented 216-219, to show all the punches irrespective of delegating status

          if (
            !MANAGE_FOR_BY_COUNTRY &&
            selectedTeamOnReview?.team === "otherTeam"
          ) {
            data = data.filter((item) =>
              item?.worker?.approvingManager?.includes(user.workerId)
            );
          }
          if (data && data.length > 0) {
            data = udpatePunchStatus(data);
            let dataToShow = data.filter(function (e) {
              return e.status.toUpperCase() != DELETED_STATUS.toUpperCase();
            });
            setData(dataToShow);
            setLoadingError(SET_EMPTY);
          } else {
            setLoadingError("pgReview.noPunchesToReport");
          }
          setIsLoading(false);
        })
        .catch((err) => {
          setIsLoading(false);
          setLoadingError("pgReview.errLoadingWorkerList");
          console.error("ReportView: Err in getWorkerByMgr Response: ", err);
        });
    } else if (userLoading) {
      console.log("Continue loading google user's data from IRM DB!");
    } else {
      setIsLoading(false);
      setLoadingError("pgReview.errLoadingWorkerId");
      console.log(
        "ReportView: else in getWorkerByMgr condition: No Logged in worker details found!"
      );
    }
  }, [
    userLoading,
    props.weekStartDate,
    props.selectedTeam,
    selectedTeamOnReview,
  ]);

  /**
   * function to update the selected punch Id
   * @return: {void}
   */
  const onRowSelectionChange = (currentRows, allRows, rowsSelected) => {
    console.log("onRowSelectionChange: ", currentRows, allRows, rowsSelected);

    let newSelectedPunches = [];
    rowsSelected.map((n) => {
      newSelectedPunches.push(data[n].id);
    });
    setSelectedPunches(newSelectedPunches);
    setRowsSelected(rowsSelected);
    console.log("Selected Punches ", newSelectedPunches);
  };

  /**
   * function to check if a punch record is selectable
   * @return: {boolean}
   */
  const isRowSelectable = (dataIndex, selectedRows, objects) => {
    console.log("isRowSelectable: ", dataIndex, selectedRows, objects);
    if (data[dataIndex]) {
      let selectable = [PENDING_STATUS];
      if (data[dataIndex].editable === false) {
        return false;
      }
      if (selectable.indexOf(data[dataIndex].status) >= 0) return true;
      else return false;
    }
  };

  /**
   * function to approve selected punch records.
   * @return: {void}
   */
  const approveHandler = () => {
    const punchIds = selectedPunches;
    const approvedPunchIndexes = [];
    console.log("AllPunchView: approveHandler: punchRecords=", punchIds);
    setIsApproveLoading(true);
    setApproveError("");
    // Check if any punch records are selected for approval.
    if (punchIds.length > 0) {
      approvePunch(punchIds, user.workerId)
        .then((punchData) => {
          data.map((item, index) => {
            if (selectedPunches.indexOf(item.id) >= 0) {
              item.status = "approved";
              approvedPunchIndexes.push(index);
            }
          });
          setIsApproveLoading(false);
          setApproveError("");
          setSelectedPunches([]); // Reset selected Punches.
          setRowsSelected([]);
          setApproveSuccess("pgReview.msgApproveSuccess");
          setTimeout(() => setApproveSuccess(""), SUCCESS_MSG_SHOWTIME);
          console.log("PUNCHES APPROVED===", punchData);
        })
        .catch((err) => {
          console.error("Err in approval of punches: ", err);
          setIsApproveLoading(false);
          setApproveError("pgReview.errApprovingPunchRecords");
        });
    } else {
      setIsApproveLoading(false);
      setApproveError("pgReview.errNothingToApprove");
    }
  };

  /**
   * function to delete selected punch records.
   * @return: {void}
   */
  const deleteHandler = () => {
    const punchIds = selectedPunches;
    let deletedPunchIndexes = [];
    console.log("AllPunchView: deleteHandler: punchRecords=", punchIds);
    setIsDeleteLoading(true);
    setDeleteError("");
    // Check if any punch records are selected for deletion.
    if (punchIds.length > 0) {
      deletePunch(punchIds, user.workerId)
        .then((punchData) => {
          data.map((item, index) => {
            if (selectedPunches.indexOf(item.id) >= 0) {
              deletedPunchIndexes.push(index);
            }
          });
          setIsDeleteLoading(false);
          setDeleteError("");
          setSelectedPunches([]); // Reset selected Punches.
          setRowsSelected([]);
          setDeleteSuccess("pgReview.msgDeleteSuccess");
          setTimeout(() => setDeleteSuccess(""), SUCCESS_MSG_SHOWTIME);
          console.log("PUNCHES DELETED===", punchData);
          handleDeleteRows();
          setConfirmDialog({ ...confirmDialog, isOpen: false });
        })
        .catch((err) => {
          console.error("Err in deletion of punches: ", err);
          setIsDeleteLoading(false);
          setDeleteError("pgReview.errDeletingPunchRecords");
        });
    } else {
      setIsDeleteLoading(false);
      setDeleteError("pgReview.errNothingToDelete"); //to be done translations in all lan
    }
  };

  /**
   * function to delete selected punch records from frontend.
   * @return: {void}
   */
  const handleDeleteRows = () => {
    const punchIds = selectedPunches;
    if (punchIds.length > 0) {
      for (let i = 0; i < punchIds.length; i++) {
        const punchId = punchIds[i];
        data.map((item, index) => {
          if (punchId === item.id) {
            data.splice(index, 1);
          }
        });
      }
      setData(data);
      setSelectedPunches([]); // Reset selected Punches.
      setRowsSelected([]);
      console.log("Handle Delete Rows Completed.");
    }
  };
  const columns = [
    {
      name: "workerId",
      label: properCase(t("pgReview.tableHeads.employeeId")),
      options: {
        display: false,
        filter: true,
        filterType: "dropdown",
        filterList: allPunchViewFiltersData[0].length
          ? allPunchViewFiltersData[0]
          : null,
      },
    },
    {
      name: "name",
      label: properCase(t("pgReview.tableHeads.name")),
      options: {
        filter: true,
        filterType: "dropdown",
        filterList: allPunchViewFiltersData[1].length
          ? allPunchViewFiltersData[1]
          : null,
      },
    },
    {
      name: "jobName",
      label: properCase(t("pgReview.tableHeads.jobFamily")),
      options: {
        filter: true,
        filterList: allPunchViewFiltersData[2].length
          ? allPunchViewFiltersData[2]
          : null,
      },
    },
    {
      name: "activityGroup",
      label: properCase(t("pgReview.tableHeads.activityGroup")),
      options: {
        filter: true,
        filterList: allPunchViewFiltersData[3].length
          ? allPunchViewFiltersData[3]
          : null,
      },
    },
    {
      label: properCase(t("pgReview.tableHeads.buildingId")),
      name: "buildingId",
      options: {
        filter: true,
        filterList: allPunchViewFiltersData[4].length
          ? allPunchViewFiltersData[4]
          : null,
      },
    },
    {
      label: properCase(t("pgReview.tableHeads.projectInfo")),
      name: "jobProjectInfo",
      options: {
        filter: true,
        display: true,
        viewColumns: true,
        filterList: allPunchViewFiltersData[5].length
          ? allPunchViewFiltersData[5]
          : null,
        filterOptions: {
          renderValue: (v) => (v !== SET_EMPTY ? v : blank),
        },
        customFilterListOptions: {
          render: (v) => (v !== SET_EMPTY ? v : blank),
        },
      },
    },
    {
      label: properCase(t("pgReview.tableHeads.exceptionType")),
      name: "exceptionName",
      options: {
        filter: true,
        filterList: allPunchViewFiltersData[6].length
          ? allPunchViewFiltersData[6]
          : null,
        filterOptions: {
          renderValue: (v) =>
            v === "no exception" || v === SET_EMPTY ? blank : v,
        },
        customFilterListOptions: {
          render: (v) => (v === "no exception" || v === SET_EMPTY ? blank : v),
        },
        customBodyRender: (value) => {
          return value === "no exception" ? SET_EMPTY : value;
        },
      },
    },
    {
      label: properCase(t("pgReview.tableHeads.startDate")),
      name: "inLocalTS",
      options: {
        sort: true,
        filter: true,
        download: false,
        filterList:
          allPunchViewFiltersData[7] && allPunchViewFiltersData[7].length
            ? allPunchViewFiltersData[7]
            : null,
        customBodyRender: (value) => {
          return date(value);
        },
      },
    },
    {
      label: properCase(t("pgReview.tableHeads.startTime")),
      name: "inLocalTS",
      options: {
        sort: true,
        filter: false,
        download: false,
        filterList:
          allPunchViewFiltersData[8] && allPunchViewFiltersData[8].length
            ? allPunchViewFiltersData[8]
            : null,
        customBodyRender: (value) => {
          return time(value);
        },
      },
    },
    {
      label: properCase(t("pgReview.tableHeads.endDate")),
      name: "outLocalTS",
      options: {
        display: false,
        sort: true,
        filter: false,
        download: false,
        filterList:
          allPunchViewFiltersData[9] && allPunchViewFiltersData[9].length
            ? allPunchViewFiltersData[9]
            : null,
        customBodyRender: (value) => {
          return date(value);
        },
      },
    },
    {
      label: properCase(t("pgReview.tableHeads.endTime")),
      name: "outLocalTS",
      options: {
        sort: true,
        filter: false,
        download: false,
        filterList:
          allPunchViewFiltersData[10] && allPunchViewFiltersData[10].length
            ? allPunchViewFiltersData[10]
            : null,
        customBodyRender: (value) => {
          return time(value);
        },
      },
    },
    {
      label: properCase(t("pgReview.tableHeads.duration")),
      name: "duration",
      options: {
        filter: false,
        filterList:
          allPunchViewFiltersData[11] && allPunchViewFiltersData[11].length
            ? allPunchViewFiltersData[11]
            : null,
      },
    },
    {
      label: properCase(t("pgReview.tableHeads.status")),
      name: "status",
      options: {
        filter: true,
        filterList:
          allPunchViewFiltersData[12] && allPunchViewFiltersData[12].length
            ? allPunchViewFiltersData[12]
            : null,
        customBodyRenderLite: (dataIndex) => {
          if (data[dataIndex]) {
            const { status, statusException, editable, jobName } =
              data[dataIndex];
            const statusLink = (
              <>
                {/* {APPROVED_STATUS.toUpperCase() === status.toUpperCase() || statusException ? ( // ENMO-949 to edit approved */}
                {statusException || editable === false ? (
                  status.toUpperCase()
                ) : (
                  <Link
                    title={t("pgReview.tableStaticText.btnEdit")}
                    style={{ textDecoration: "none" }}
                    to={{
                      pathname:
                        PTO === jobName
                          ? SUPERVISOR_PTO
                          : ADD_EDIT_PUNCH_SUPERVISOR,
                      state: {
                        punch: data[dataIndex],
                        worker: data[dataIndex]["worker"],
                        isAllPunch: true,
                      },
                    }}
                  >
                    <Typography variant="body2">
                      {status.toUpperCase()}
                    </Typography>
                  </Link>
                )}
              </>
            );
            return statusLink;
          }
        },
      },
    },
    {
      // Added to include the formatted start date in the downloaded csv
      label: properCase(t("pgReview.tableHeads.startDate")),
      name: "startDate",
      options: {
        download: true,
        display: false,
        filter: false,
        viewColumns: false,
        filterList:
          allPunchViewFiltersData[13] && allPunchViewFiltersData[13].length
            ? allPunchViewFiltersData[13]
            : null,
      },
    },
    {
      // Added to include the formatted start time in the downloaded csv
      label: properCase(t("pgReview.tableHeads.startTime")),
      name: "startTime",
      options: {
        download: true,
        display: false,
        filter: false,
        viewColumns: false,
        filterList:
          allPunchViewFiltersData[14] && allPunchViewFiltersData[14].length
            ? allPunchViewFiltersData[14]
            : null,
      },
    },
    {
      // Added to include the formatted end date in the downloaded csv
      label: properCase(t("pgReview.tableHeads.endDate")),
      name: "endDate",
      options: {
        download: true,
        display: false,
        filter: false,
        viewColumns: false,
        filterList:
          allPunchViewFiltersData[15] && allPunchViewFiltersData[15].length
            ? allPunchViewFiltersData[15]
            : null,
      },
    },
    {
      // Added to include the formatted end time in the downloaded csv
      label: properCase(t("pgReview.tableHeads.endTime")),
      name: "endTime",
      options: {
        download: true,
        display: false,
        filter: false,
        viewColumns: false,
        filterList:
          allPunchViewFiltersData[16] && allPunchViewFiltersData[16].length
            ? allPunchViewFiltersData[16]
            : null,
      },
    },
  ];

  //refs for total values
  let totalDurationRef = useRef();
  let totalActivityRef = useRef();
  let totalMealRef = useRef();

  //an array which stores the current rows being dispalyed on the table
  let totalArray = [];
  let activityArray = [];
  let mealArray = [];

  //stores the total values
  let totalHours = 0;
  let activityHours = 0;
  let mealHours = 0;

  const options = {
    filter: true,
    download: true,
    downloadOptions: { filename: downloadFileNameAllPunch },
    print: false,
    filterType: "multiselect",
    responsive: "standard",
    selectableRows: "multiple",
    onRowSelectionChange,
    isRowSelectable,
    rowsSelected: rowsSelected,
    customToolbarSelect: () => {},
    onFilterChange: (columnChanged, filterList) => {
      //console.log("---filterList----",filterList);
      //console.log("----columnChanged-----",columnChanged);

      dispath(saveAllPunchViewFilterList(filterList));
    },
    setFilterChipProps: (colIndex, colName, data) => {
      console.log(colIndex, colName, data);
      return {
        style: { color: "#1B75BC", border: "1px solid #1B75BC" },
        variant: "outlined",
      };
    },
    // apply background color to rows with incomplete status
    setRowProps: (row, dataIndex, rowIndex) => {
      const bgWithinRange = INCOMPLETE_BG_VALID;
      const bgOutOfRange = INCOMPLETE_BG_INVALID;
      if (data[dataIndex]) {
        //procedure for showing different totals
        let tempTot = parseFloat(
          parseFloat(data[dataIndex].duration) + totalHours
        );
        if (data[dataIndex].activityGroup !== "Meal") {
          let tempactTot = parseFloat(
            parseFloat(data[dataIndex].duration) + activityHours
          );
          if (!activityArray.includes(dataIndex)) {
            activityArray.push(dataIndex);
            setActivityDuration(tempactTot);
          }
        }

        if (data[dataIndex].activityGroup == "Meal") {
          let tempMealTot = parseFloat(
            parseFloat(data[dataIndex].duration) + mealHours
          );
          if (!mealArray.includes(dataIndex)) {
            mealArray.push(dataIndex);
            setMealDuration(tempMealTot);
          }
        }

        if (!totalArray.includes(dataIndex)) {
          totalArray.push(dataIndex);
          setTotalDuration(tempTot);
        }
        //different toal calculation ends here

        if (parseFloat(data[dataIndex].duration) > TWELVE) {
          return {
            style: { backgroundColor: DURATION_GT_12 },
          };
        }
        const { endDate, endTime, startDate, startTime } = data[dataIndex];
        if (!(endDate && endTime && startDate && startTime)) {
          let applyColor =
            startDate &&
            moment().diff(moment(startDate, dateConfig.format3), "days") > 14
              ? bgOutOfRange
              : bgWithinRange;
          return {
            style: { backgroundColor: applyColor },
          };
        }
        return {};
      }
    },
    setTableProps: () => {
      setTotalDuration(0);
      setActivityDuration(0);
      setMealDuration(0);
    },
    onTableChange: () => {
      totalArray = [];
      activityArray = [];
      mealArray = [];
    },
    rowsPerPageOptions: defaultPaginationOptions,
    textLabels: getTextLabels(t),
  };

  const setTotalDuration = (val) => {
    totalHours = val;
    if (totalDurationRef.current) {
      totalDurationRef.current.innerText = parseFloat(totalHours).toFixed(2);
    }
  };

  const setActivityDuration = (val) => {
    activityHours = val;
    if (totalActivityRef.current) {
      totalActivityRef.current.innerText = parseFloat(activityHours).toFixed(2);
    }
  };

  const setMealDuration = (val) => {
    mealHours = val;
    if (totalMealRef.current) {
      totalMealRef.current.innerText = parseFloat(mealHours).toFixed(2);
    }
  };

  return (
    <>
      {
        isLoading ? (
          <>
            <CircularProgress />
            <Typography variant="body2">
              {t("pgReview.loadingGoogleUserDetails")}
            </Typography>
          </>
        ) : loadingError ? (
          <Typography variant="body2" color="error">
            {/* {t(loadingError)} */}
            <Alert severity="info">{t(loadingError)}</Alert>
          </Typography>
        ) : null
        //allPunchMarkup
      }
      <div className={isLoading || loadingError ? classes.hideElem : ""}>
        <>
          <MuiThemeProvider theme={reportTheme}>
            <MUIDataTable
              title={properCase(t("pgHome.btnReviewPunches"))}
              data={data}
              columns={columns}
              options={options}
            />
            <Card className={classes.container}>
              <span className={classes.label1}>Activity Hours</span>
              <span className={classes.label2} ref={totalActivityRef}></span>
              <span className={classes.label1}>Meal Hours</span>
              <span className={classes.label2} ref={totalMealRef}></span>
              <span className={classes.label1}>
                {properCase(t("pgReview.totalHours"))}
              </span>
              <span className={classes.label2} ref={totalDurationRef}></span>
            </Card>
          </MuiThemeProvider>
          <Grid container justify={"flex-end"} spacing={3}>
            <Grid item>
              <Box my={8}>
                <LoadingButton
                  onClick={() =>
                    setConfirmDialog({
                      isOpen: true,
                    })
                  } //{deleteHandler}
                  isLoading={isDeleteLoading}
                  disabled={rowsSelected.length <= 0}
                >
                  {t("pgReview.btnDelete")}
                </LoadingButton>
                <Typography variant="body2" color="error">
                  {t(deleteError)}
                </Typography>
                <Typography variant="body2">{t(deleteSuccess)}</Typography>
              </Box>
            </Grid>
            <Grid item>
              <Box my={8}>
                <LoadingButton
                  onClick={approveHandler}
                  isLoading={isApproveLoading}
                  disabled={rowsSelected.length <= 0}
                >
                  {t("pgReview.btnApprove")}
                </LoadingButton>
                <Typography variant="body2" color="error">
                  {t(approveError)}
                </Typography>
                <Typography variant="body2">{t(approveSuccess)}</Typography>
              </Box>
            </Grid>
          </Grid>
          <Dialog
            open={confirmDialog.isOpen}
            className={classes.dialog}
            disableBackdropClick
          >
            <DialogTitle id="form-dialog-title">
              {t("pgPunch.tlConfirmation")}
            </DialogTitle>
            <DialogContent>
              <DialogContentText>
                {t("pgReview.msgDeleteConfirmation")}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                variant="contained"
                color="primary"
                onClick={deleteHandler}
              >
                {t("pgReview.btnYes")}
              </Button>
              <Button
                variant="outlined"
                color="primary"
                onClick={() =>
                  setConfirmDialog({ ...confirmDialog, isOpen: false })
                }
              >
                {t("pgReview.btnNo")}
              </Button>
            </DialogActions>
          </Dialog>
        </>
      </div>
    </>
  );
};

AllPunchView.propTypes = {
  weekStartDate: PropTypes.any.isRequired,
  allWorkers: PropTypes.object.isRequired,
  selectedTeam: PropTypes.string.isRequired,
};
export default AllPunchView;
